export const ON_SUCCESS = "ON_SUCCESS";
export const ON_FAILURE = "ON_FAILURE";
export const ON_WARNING = "ON_WARNING";
